import TopBar from "../../components/Layout/TopBar";
import React, {useEffect, useState} from "react";
import ClipLoader from "react-spinners/ClipLoader";
import {useAlert} from 'react-alert';
import useAuthz from "../../hooks/useAuthz";
import {useNavigate} from 'react-router';
import {FormControl, Paper, TextField} from "@mui/material";
import axios from "axios";
import {URL_API} from "../../utils/globalConfig";
import {logError} from "../../components/Utils/FormatData";
import moment from "moment";
import FormLabel from "@mui/material/FormLabel";
import {DatePicker} from "@mui/x-date-pickers";
import MyButton from "../../components/Layout/MyButton";

const statistiqueStyle = {
  row: {
    alignItems: 'center',
    alignContent: 'center',
    marginTop: ' -100px',
  },
  stat: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  title: {
    fontSize: '22px',
    margin: '5px'
  },
  value: {
    fontWeight: 'bold',
    fontSize: '40px',
    margin: '5px',
    color: '#0094ca'
  },
  textField: {
    width: '50%',
    margin: '20px'
  },
}

const Statistiques = (props) => {
  const alert = useAlert();
  const [authz, user, profil] = useAuthz();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [stats, setStats] = useState({
    nbRequest: 0,
    nbProcessed: 0,
    nbRefused: 0,
    nbInProgress: 0,
    averageDuration: 0
  });
  const [selectedYear, setSelectedYear] = useState(moment().format("YYYY"));

  //#region Fonctions

  useEffect(() => {
    if (profil.profil === 6) {
      alert.error('Vous n\'êtes pas autorisé à accéder à la blacklist');
      navigate('/');
    }
    document.title = 'TE - Statistiques';
    loadStatistiques();
  }, []);

  useEffect(() => {
    if (selectedYear) {
      loadStatistiques();
    }
  }, [selectedYear]);

  //#endregion

  //#region API

  const loadStatistiques = () => {
    setIsLoading(true);

    const apiGetNbRequestByYear = axios({method: 'get', url: URL_API + '/statistique/getNbRequestByYear', params: {year: moment(selectedYear).year()}});
    const apiGetNbAcceptedRequest = axios({method: 'get', url: URL_API + '/statistique/getNbProcessedRequest', params: {year: moment(selectedYear).year()}});
    const apiGetNbRefusedRequest = axios({method: 'get', url: URL_API + '/statistique/getNbRefusedRequest', params: {year: moment(selectedYear).year()}});
    const apiGetNbInProgressRequest = axios({method: 'get', url: URL_API + '/statistique/getNbInProgressRequest', params: {year: moment(selectedYear).year()}});
    const apiGetAverageDurationRequestTreatment = axios({
      method: 'get',
      url: URL_API + '/statistique/getAverageDurationRequestTreatment',
      params: {year: moment(selectedYear).year()}
    });

    Promise.all([apiGetNbRequestByYear, apiGetNbAcceptedRequest, apiGetNbRefusedRequest, apiGetNbInProgressRequest, apiGetAverageDurationRequestTreatment])
      .then((values) => {
        setStats({
          nbRequest: values[0].data,
          nbProcessed: values[1].data,
          nbRefused: values[2].data,
          nbInProgress: values[3].data,
          averageDuration: values[4].data
        });
        setIsLoading(false);
      })
      .catch((err) => {
        logError(alert, err);
      });
  };

  //#endregion

  // region functions
  const handleChangeYear = (newValue) => {
    setSelectedYear(newValue);
  }
  // endregion

  return (
    <div style={{height: 'calc(100% - 50px)'}}>
      <TopBar title="Statistiques" className='topbar-contenu' color={props.params.color}
              buttons={
                <div className='topbar-buttons'>
                  <MyButton onClick={() => navigate("/panneau-administration")} icon={''} label={'Retour'}/>
                </div>
              }
      />
      <div className='row' style={{margin: 0, overflow: 'hidden'}}>
        <ClipLoader color='#0094ca' loading={isLoading} size={75} css={'display: flex; margin: 25px;justify-content: center;'}/>
        {!isLoading && (
          <div>
            <div>
              <FormControl style={{marginLeft: '30px'}}>
                <FormLabel>Choisissez l'année</FormLabel>
                <DatePicker
                  views={['year']}
                  label="ANNÉE"
                  name="year"
                  value={selectedYear || null}
                  style={{...statistiqueStyle.textField, width: '30%'}}
                  onChange={(newValue) => handleChangeYear(newValue)}
                  renderInput={(params) => <TextField {...params} />}
                  inputVariant="outlined"
                  minDate={new Date(moment("01-01-2022").subtract(2, "years").startOf("year").format())}
                  maxDate={new Date()}
                />
              </FormControl>
            </div>
            <div className='row' style={statistiqueStyle.row}>
              <Paper className={"module-admin"}>
                <div style={statistiqueStyle.stat}>
                  <p style={statistiqueStyle.title}>Nombre de demandes / an</p>
                  <p style={statistiqueStyle.value}>{stats.nbRequest}</p>
                </div>
              </Paper>

              <Paper className={"module-admin"}>
                <div style={statistiqueStyle.stat}>
                  <p style={statistiqueStyle.title}>Nombre de dossiers traités / an</p>
                  <p style={statistiqueStyle.value}>{stats.nbProcessed}</p>
                </div>
              </Paper>

              <Paper className={"module-admin"}>
                <div style={statistiqueStyle.stat}>
                  <p style={statistiqueStyle.title}>Nombre de dossiers refusés / an</p>
                  <p style={statistiqueStyle.value}>{stats.nbRefused}</p>
                </div>
              </Paper>

              <Paper className={"module-admin"}>
                <div style={statistiqueStyle.stat}>
                  <p style={statistiqueStyle.title}>Nombre de dossiers en cours</p>
                  <p style={statistiqueStyle.value}>{stats.nbInProgress}</p>
                </div>
              </Paper>

              <Paper className={"module-admin"}>
                <div style={statistiqueStyle.stat}>
                  <p style={statistiqueStyle.title}>Durée moyenne de traitement d'un dossier</p>
                  <p style={statistiqueStyle.value}>{stats.averageDuration || 0} jours</p>
                </div>
              </Paper>
            </div>
          </div>

        )}
      </div>
    </div>
  );

}

export default Statistiques;
